export default {
    billingTime() {
        if (this.billingTime > 30) {
            this.errors['billingTime'] = 'O prazo de faturamento não pode ser maior que 30 dias'
        } else {
            this.errors['billingTime'] = ''
        }
    }
}
